import { useTranslation } from 'react-i18next';

export default function BuenlugarCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-36 px-4 md:px-10 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/38ed6879-876a-49b1-a929-4133d0727550_compressed_Captura-de-pantalla-2026-07-16-a-las-14.19.04.webp"
          alt="Villa Buenlugar - Terrace with outdoor dining and mountain views"
          title="Villa Buenlugar - Terrace with outdoor dining and mountain views"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center text-white">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
          {t('cta_buenlugar_title')}
        </h2>
        <p className="text-base md:text-lg text-white/80 mb-8 font-light">
          {t('cta_buenlugar_subtitle')}
        </p>
        <a
          href="#search"
          className="inline-block bg-primary-500 hover:bg-primary-600 text-white px-10 py-4 rounded-md text-base md:text-lg font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer hover:scale-105 transform"
        >
          {t('cta_reserve')}
        </a>
      </div>
    </section>
  );
}